import { Outlet } from "react-router-dom";
import { useState } from "react";
import { SideBar } from "./Sidebar";
import DeletePopup from "../../components/DeletePopup";
import { UserProfile } from "../userProfile/UserProfile";

export const AdminLayout = () => {
    const [fullScreen, setFullScreen] = useState<boolean>(true);

    const handleScreen = () => {
        setFullScreen(!fullScreen);
    }

    return (
        <div className="flex bg-blue-50">
            <SideBar handleScreen={handleScreen} />
            <div className={`${fullScreen ? 'w-[calc(100%-224px)]' : 'w-[calc(100%-50px)]'} h-max`}>
                <Outlet />
                <DeletePopup />
                <UserProfile />
            </div>
        </div>
    );
};